import { useContext, useEffect, useRef } from "react";
import { StateContext } from "../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../context/globalContext/interface";
import { useFlightDataUpdate, useStayUpdate } from "../../../../helpers/updateFlightAndStayData";
import { extractBookingUpdateFromUrl } from "../../../../helpers/extractBookingUpdateFromUrl";
import { extractFlightDataFromUrl, extractStayDataFromUrl } from "../../../../helpers/extractFlightAndStayDataFromUrl";
import { useNavigationUrl } from "../../../../hooks/useNavigationUrl";
import { ROUTES } from "../../../../constant";
import { ScreenTypes } from "../../../../enums";

export const useBookingUrlSync = () => {
  const {
    userInfo,
    setOnBoardForm,
    setShouldAutoCallSearchFlightHotel,
    setSelectedFlightOptions,
    isMobile,
    setFirstScreen,
    setHideDetails,
  }: iGlobalContext = useContext(StateContext);

  const { navigateWithParams } = useNavigationUrl();
  const bookingFromUrl = extractBookingUpdateFromUrl(window.location.href);
  const handleFlightUpdate = useFlightDataUpdate();
  const handleStayUpdate = useStayUpdate();
  const hasProcessedUrlRef = useRef(false);

  useEffect(() => {
    if (!userInfo?.loggedIn) return;
    if (hasProcessedUrlRef.current) return;
    hasProcessedUrlRef.current = true;
    const currentUrl = window.location.href;

    const isFlightStay = currentUrl.includes("book_flight_stay");
    const isFlightOnly = currentUrl.includes("book_flight") && !isFlightStay;
    const isStayOnly = currentUrl.includes("book_stay") && !isFlightStay;
    setHideDetails(false);
    if (isFlightStay) {
      const flightData = extractFlightDataFromUrl(currentUrl);
      const stayData = extractStayDataFromUrl(currentUrl);

      handleFlightUpdate(flightData);
      handleStayUpdate(stayData);
    }

    if (isFlightOnly) {
      const flightData = extractFlightDataFromUrl(currentUrl);
      handleFlightUpdate(flightData);
    }

    if (isStayOnly) {
      const stayData = extractStayDataFromUrl(currentUrl);
      handleStayUpdate(stayData);
    }

    if (isFlightStay || isFlightOnly || isStayOnly) {
      setShouldAutoCallSearchFlightHotel(true);

      setSelectedFlightOptions({
        flights: isFlightStay || isFlightOnly,
        hotels: isFlightStay || isStayOnly,
        activities: false,
      });

      isMobile ? navigateWithParams(ROUTES.BookingInProgress) : setFirstScreen(ScreenTypes.newBooking);
    }

    setOnBoardForm((prev) => {
      const promo = bookingFromUrl.promoCode;
      if (prev.signUpOffer === promo && prev.isOfferAvailable === Boolean(promo)) {
        return prev;
      }

      return {
        ...prev,
        signUpOffer: promo,
        isOfferAvailable: Boolean(promo),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.loggedIn]);

  return { bookingFromUrl };
};
